<template>
    <ion-page>
        <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-button @click="closeModal()">
                        <ion-icon slot="start" :icon="arrowBackOutline" color="white"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title color="white">Nuova richiesta</ion-title>
            </ion-toolbar>
        </ion-header>

        <ion-content :fullscreen="true">
            <div class="page_content">
                <form @submit.prevent="creaRichiesta()">
                    <ion-list class="fields">
                        <!-- Tipologia -->
                        <ion-item lines="none" class="ion-no-padding">
                            <div class="field">
                                <div class="field_title">Tipologia <span class="required">*</span></div>
                                <div class="value">
                                    <ion-select name="tipologia" interface="action-sheet" cancel-text="Annulla"
                                        ok-text="Conferma" v-model="richiesta.tipologia" placeholder="Seleziona"
                                        @ionChange="toggleField($event.target.value)">
                                        <ion-select-option v-for="tipologia in tipologie_richiesta"
                                            :key="tipologia.richieste_tipologia_id"
                                            :value="tipologia.richieste_tipologia_id">
                                            {{ tipologia.richieste_tipologia_value }}
                                        </ion-select-option>
                                    </ion-select>
                                </div>
                            </div>
                        </ion-item>

                        <!-- Sottotipologia -->
                        <ion-item v-if="showSottocategorie" lines="none" class="ion-no-padding">
                            <div class="field">
                                <div class="field_title">
                                    Categoria
                                </div>
                                <div class="value">
                                    <ion-select name="sottotipologia" interface="action-sheet" cancel-text="Annulla"
                                        ok-text="Conferma" v-model="richiesta.sottotipologia" placeholder="Seleziona"
                                        @ionChange="setSottotipologia($event.target.value)">
                                        <ion-select-option v-for="categoria in sottotipologie"
                                            :key="categoria.richieste_sottotipologia_id"
                                            :value="categoria.richieste_sottotipologia_id">
                                            {{ categoria.richieste_sottotipologia_value }}
                                        </ion-select-option>
                                    </ion-select>
                                </div>
                            </div>
                        </ion-item>

                        <!-- Data inizio -->
                        <ion-item lines="none" class="ion-no-padding">
                            <div class="field">
                                <div class="field_title">Data inizio <span class="required">*</span></div>
                                <div class="value">
                                    <ion-datetime name="date_start" display-format="DD/MM/YYYY"
                                        picker-format="DD/MM/YYYY" min="2025" max="2099" slot="end" doneText="OK"
                                        cancelText="Annulla" v-model="richiesta.data_inizio"></ion-datetime>
                                </div>
                            </div>
                        </ion-item>

                        <!-- Data fine -->
                        <ion-item v-if="showDataFine" lines="none" class="ion-no-padding">
                            <div class="field">
                                <div class="field_title">Data fine</div>
                                <div class="value">
                                    <ion-datetime name="date_end" display-format="DD/MM/YYYY" picker-format="DD/MM/YYYY"
                                        min="2025" max="2099" slot="end" doneText="OK" cancelText="Annulla"
                                        v-model="richiesta.data_fine" placeholder="gg/mm/aaaa"></ion-datetime>
                                </div>
                            </div>
                        </ion-item>

                        <!-- Ora inizio -->
                        <ion-item lines="none" class="ion-no-padding" v-show="showOrario">
                            <div class="field">
                                <div class="field_title">Ora inizio</div>
                                <div class="value">
                                    <ion-datetime name="start_time" display-format="HH:mm" picker-format="HH:mm"
                                        slot="end" doneText="OK" cancelText="Annulla" v-model="richiesta.ora_inizio"
                                        placeholder="Seleziona ora di inizio"></ion-datetime>
                                </div>
                            </div>
                        </ion-item>

                        <!-- Ora fine -->
                        <ion-item lines="none" class="ion-no-padding" v-show="showOrario">
                            <div class="field">
                                <div class="field_title">Ora fine</div>
                                <div class="value">
                                    <ion-datetime name="end_time" display-format="HH:mm" picker-format="HH:mm"
                                        slot="end" doneText="OK" cancelText="Annulla" v-model="richiesta.ora_fine"
                                        placeholder="Seleziona ora di fine"></ion-datetime>
                                </div>
                            </div>
                        </ion-item>

                        <!-- Protocollo INPS -->
                        <ion-item lines="none" class="fieion-no-padding" v-show="showProtocolloInps">
                            <div class="field">
                                <div class="field_title" position="floating">
                                    Protocollo INPS
                                </div>
                                <div class="value">
                                    <ion-input type="text" v-model="richiesta.protocollo_inps"
                                        placeholder="Inserisci n° pratica INPS"></ion-input>
                                </div>
                            </div>
                        </ion-item>

                        <!-- Note -->
                        <ion-item lines="none" class="field ion-no-padding">
                            <div class="field">
                                <div class="field_title" position="floating">Note</div>
                                <div class="value">
                                    <ion-textarea type="text" rows="3" v-model="richiesta.note"
                                        placeholder="Inserisci eventuali note delle richiesta">
                                    </ion-textarea>
                                </div>
                            </div>
                        </ion-item>

                        <!-- Allegato -->
                        <ion-item lines="none" class="fieion-no-padding">
                            <div class="field">
                                <div class="section_title">Allegati</div>
                                <label for="file-upload" class="btn_select_allegato">
                                    <ion-icon :icon="attachOutline"></ion-icon>
                                </label>
                                <input id="file-upload" type="file" @change="selezionaAllegato($event)" />

                                <span v-if="currentFile" class="file_name">
                                    <div class="file_name_title">
                                        {{ currentFile.name }}
                                    </div>
                                    <div class="remove_allegato">
                                        <ion-icon :icon="trash" @click="removeAllegato()"
                                            class="icon_remove"></ion-icon>
                                    </div>
                                </span>
                            </div>
                        </ion-item>

                        <!-- Banca ore -->
                        <ion-item v-if="showBancaOre && showBancaOreSettings" lines="none" class="field ion-no-padding">
                            <div class="field">
                                <div class="field_title" position="floating">Vuoi usare le ore della banca ore?</div>
                                <div class="value">
                                    <ion-radio-group value="0" @ionChange="setUsaBancaOre($event)">
                                        <ion-item lines="none" class="ion-no-padding">
                                            <ion-label>No</ion-label>
                                            <ion-radio slot="start" value="0"></ion-radio>
                                        </ion-item>
                                        <ion-item lines="none" class="ion-no-padding">
                                            <ion-label>Sì</ion-label>
                                            <ion-radio slot="start" value="1"></ion-radio>
                                        </ion-item>
                                    </ion-radio-group>
                                </div>
                            </div>
                        </ion-item>

                        <ion-item lines="none" class="fieion-no-padding">
                            <div class="actions">
                                <button type="submit" class="btn_richiesta" :disabled="sendingRequest">
                                    Invia richiesta
                                </button>
                            </div>
                        </ion-item>
                    </ion-list>
                </form>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonPage,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    modalController,
    IonList,
    IonItem,
    IonDatetime,
    IonTextarea,
    IonInput,
    IonSelect,
    IonSelectOption,
    IonIcon,
    IonRadioGroup,
    IonRadio,
    IonLabel,
} from "@ionic/vue";
import { arrowBackOutline, trash, attachOutline } from "ionicons/icons";

import { defineComponent, ref, reactive, watch, onMounted } from "vue";

import { LOCALSTORAGE_KEY } from "@/custom_config";

import moment from "moment";

import { openToast } from "@/services/toast";
import apiRichieste from "@/services/richieste";
import apiImpostazioniHr from "@/services/impostazioni_hr";

export default defineComponent({
    name: "ModalNuovaRichiesta",
    components: {
        IonPage,
        IonContent,
        IonHeader,
        IonTitle,
        IonToolbar,
        IonButtons,
        IonButton,
        IonList,
        IonItem,
        IonDatetime,
        IonTextarea,
        IonInput,
        IonSelect,
        IonSelectOption,
        IonIcon,
        IonRadioGroup,
        IonRadio,
        IonLabel,
    },
    setup(props, context) {
        const start_date = new Date();
        const end_hour = new Date();
        const start_hour = new Date(end_hour);
        start_hour.setHours(start_hour.getHours() + 1);
        end_hour.setHours(start_hour.getHours() + 2);

        const userID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).users_id; //set userID in user field
        const dipendenteID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_id;

        const richiesta = reactive({
            user: "", //from logged user
            data_inizio: start_date.toISOString(),
            //data_fine: start_date.toISOString(),
            data_fine: "",
            /*ora_inizio: start_hour.toISOString(),
      ora_fine: end_hour.toISOString(),*/
            ora_inizio: "",
            ora_fine: "",
            tipologia: "",
            sottotipologia: "",
            protocollo_inps: "",
            note: "",
            usa_banca_ore: 0,
            allegato: null,
        });

        const tipologie_richiesta = ref([]);
        const sottotipologie = ref([]);
        const showSottocategorie = ref(true);

        const showOrario = ref(false);
        const showProtocolloInps = ref(false);
        const showBancaOre = ref(false);
        const showDataFine = ref(true);

        const successResponse = ref(false);
        const fieldFlag = ref(false); //se tutti i campi sono ok diventa true e posso procedere con la creazione

        const selectedTipologia = ref({
            richieste_tipologia_id: 1,
            richieste_tipologia_value: "Permesso",
        });

        const impostazioni_hr = ref([]);
        const showBancaOreSettings = ref(false);
        const showPermessoDateDiverse = ref(false);
        async function loadImpostazioniHr() {
            try {
                const res = await apiImpostazioniHr.getImpostazioniHr();
                if (res.status === 200 && res.data.status === 0 && res.data.data.length > 0) {
                    impostazioni_hr.value = res.data.data[0];
                    const settings = res.data.data[0];
                    if (settings.impostazioni_hr_banca_ore) {
                        //showBancaOreSettings.value = settings.impostazioni_hr_banca_ore;
                        showBancaOreSettings.value = settings.impostazioni_hr_banca_ore == "1" ? true : false;
                    }

                    // TK 13535 - Permettere permesso su più giorni, diversamente da prima devo mostrare data fine e nascondere orari
                    // Se permesso_date_diverse è attivo, data fine sempre visibile quando si seleziona permesso
                    // Il watch gestirà il cambio dinamico quando l'utente modifica le date
                    if (settings.impostazioni_hr_permesso_date_diverse && settings.impostazioni_hr_permesso_date_diverse == "1") {
                        showPermessoDateDiverse.value = settings.impostazioni_hr_permesso_date_diverse == "1" ? true : false;
                        // Non impostiamo showDataFine qui perché verrà gestito quando si seleziona la tipologia permesso
                    } else {
                        showPermessoDateDiverse.value = false;
                        showDataFine.value = false;
                    }
                }
            } catch (error) {
                console.error(error);
                openToast("Errore durante la richiesta delle impostazioni", "toast_danger");
            }
        }

        /**
         * ! Se data inizio > data fine aggiorno con data fine = data inizio
         */
        watch(
            () => richiesta.data_inizio,
            (date, prevDate) => {
                if (richiesta.data_fine) {
                    if (moment(richiesta.data_fine).isBefore(moment(richiesta.data_inizio))) {
                        richiesta.data_fine = date;
                    }
                }
            }
        );
        /**
         * ! Se ora inizio > ora fine aggiorno con ora fine = ora inizio
         */
        watch(
            () => richiesta.ora_inizio,
            (hour, prevHour) => {
                if (richiesta.ora_fine) {
                    if (moment(richiesta.ora_fine).isBefore(moment(richiesta.ora_inizio))) {
                        richiesta.ora_fine = hour;
                    }
                }
            }
        );
        /**
         * ! Se data fine < data inizio aggiorno con data inizio = data fine
         */
        watch(
            () => richiesta.data_fine,
            (date, prevDate) => {
                if (richiesta.data_inizio) {
                    if (moment(richiesta.data_fine).isBefore(moment(richiesta.data_inizio))) {
                        richiesta.data_inizio = date;
                    }
                }
            }
        );
        /**
         * ! Se ora fine < ora inizio aggiorno con ora inizio = ora iniziofine
         */
        watch(
            () => richiesta.ora_fine,
            (hour, prevHour) => {
                if (richiesta.ora_inizio) {
                    if (moment(richiesta.ora_fine).isBefore(moment(richiesta.ora_inizio))) {
                        richiesta.ora_inizio = hour;
                    }
                }
            }
        );
        function applyTipologiaUiState(tipoRichiesta) {
            if (!tipoRichiesta) {
                showOrario.value = false;
                showProtocolloInps.value = false;
                showBancaOre.value = false;
                showDataFine.value = false;
                return;
            }

            const tipologiaSelezionata = tipologie_richiesta.value.find(
                (t) => String(t.richieste_tipologia_id) === String(tipoRichiesta)
            );
            const fullDay = isGiornataIntera(tipologiaSelezionata);

            const setOrari = (enabled) => {
                if (enabled) {
                    if (!richiesta.ora_inizio) richiesta.ora_inizio = start_hour.toISOString();
                    if (!richiesta.ora_fine) richiesta.ora_fine = end_hour.toISOString();
                } else {
                    richiesta.ora_inizio = "";
                    richiesta.ora_fine = "";
                }
                showOrario.value = enabled;
            };

            if (tipoRichiesta === "1") {
                showProtocolloInps.value = false;
                showBancaOre.value = true;
                if (showPermessoDateDiverse.value) {
                    if (!richiesta.data_fine) richiesta.data_fine = richiesta.data_inizio || start_date.toISOString();
                    showDataFine.value = true;
                    const isSameDay = moment(richiesta.data_inizio).format("YYYY-MM-DD") === moment(richiesta.data_fine).format("YYYY-MM-DD");
                    setOrari(!fullDay && isSameDay);
                } else {
                    showDataFine.value = false;
                    if (!richiesta.data_fine) richiesta.data_fine = start_date.toISOString();
                    setOrari(!fullDay);
                }
                return;
            }

            if (tipoRichiesta === "2") {
                showProtocolloInps.value = false;
                showBancaOre.value = true;
                showDataFine.value = true;
                if (!richiesta.data_fine) richiesta.data_fine = start_date.toISOString();
                setOrari(false);
                return;
            }

            if (tipoRichiesta === "3") {
                showProtocolloInps.value = true;
                showBancaOre.value = false;
                showDataFine.value = true;
                richiesta.usa_banca_ore = "";
                setOrari(false);
                return;
            }

            if (tipoRichiesta === "4") {
                showProtocolloInps.value = false;
                showBancaOre.value = false;
                showDataFine.value = false;
                if (!richiesta.data_fine) richiesta.data_fine = start_date.toISOString();
                richiesta.usa_banca_ore = "";
                setOrari(!fullDay);
                return;
            }

            if (tipoRichiesta === "5") {
                showProtocolloInps.value = false;
                showBancaOre.value = false;
                showDataFine.value = false;
                if (!richiesta.data_fine) richiesta.data_fine = start_date.toISOString();
                setOrari(!fullDay);
                return;
            }

            if (tipoRichiesta === "6" || tipoRichiesta === "7") {
                showProtocolloInps.value = false;
                showBancaOre.value = false;
                showDataFine.value = true;
                if (!richiesta.data_fine) richiesta.data_fine = start_date.toISOString();
                setOrari(!fullDay);
                return;
            }

            if (tipoRichiesta === "8") {
                showProtocolloInps.value = false;
                showBancaOre.value = false;
                showDataFine.value = false;
                if (!richiesta.data_fine) richiesta.data_fine = start_date.toISOString();
                setOrari(!fullDay);
                return;
            }

            // Tipologie personalizzate: comportamento API-driven
            showProtocolloInps.value = false;
            showBancaOre.value = false;
            showDataFine.value = true;
            if (!richiesta.data_fine) richiesta.data_fine = start_date.toISOString();
            setOrari(!fullDay);
        }

        watch(
            [
                () => richiesta.tipologia,
                () => richiesta.data_inizio,
                () => richiesta.data_fine,
                () => showPermessoDateDiverse.value,
                () => tipologie_richiesta.value.length,
            ],
            ([tipologia]) => {
                applyTipologiaUiState(tipologia);
            }
        );

        /**
         * ! Close modal after form data submit
         */
        async function closeModalOnSubmit(successResponse, res) {
            if (successResponse.value) {
                await modalController.dismiss(res);
            } else {
                await modalController.dismiss();
            }
        }

        /**
         * ! Handle close modal by clicking on Chiudi button
         */
        const closeModal = () => {
            modalController.dismiss();
        };

        /**
         * ! Get sottotipologia for selected tipologia
         */
        async function getSottotipologie(tipoRichiesta) {
            apiRichieste
                .getSottotipologieRichieste(tipoRichiesta)
                .then((response) => {
                    //Se non ho sottocategorie svuoto quelle precedentemente ottenute,
                    //svuoto l'eventuale sottocategoria già scelta e nascondo la select
                    if (response.data.length === 0) {
                        sottotipologie.value = [];
                        showSottocategorie.value = false;
                    } else {
                        showSottocategorie.value = true;
                        sottotipologie.value = response.data;
                    }
                    richiesta.sottotipologia = "";
                })
                .catch((error) => {
                    console.log(error);
                    openToast("Si è verificato un errore durante la richiesta delle sottotipologie", "toast_danger");
                });
        }

        /**
         * ! Toggle field visibility based on richiesta tipologia
         */
        function toggleField(tipoRichiesta) {
            getSottotipologie(tipoRichiesta);
            applyTipologiaUiState(tipoRichiesta);
        }

        const currentFile = ref(null);
        function selezionaAllegato(event) {
            currentFile.value = event.target.files[0];
            richiesta.allegato = currentFile.value;
        }

        function removeAllegato() {
            currentFile.value = null;
        }

        /**
         * Set richiesta.usa_banca_ore value based on selected radio
         */
        function setUsaBancaOre(event) {
            richiesta.usa_banca_ore = event.target.value;
        }

        /**
         * ! Set selected sottotipologia
         */
        function setSottotipologia(sottotipologia_id) {
            richiesta.sottotipologia = sottotipologia_id;
        }

        /**
         * Helper: legge dalla tipologia (oggetto API) se è a giornata intera
         */
        function isGiornataIntera(tipologiaObj) {
            return tipologiaObj && (tipologiaObj.richieste_tipologia_giornata_intera == 1 || tipologiaObj.richieste_tipologia_giornata_intera === "1");
        }

        /**
         * Helper: legge dalla tipologia (oggetto API) se ha approvazione automatica
         */
        function isApprovazioneAutomatica(tipologiaObj) {
            return tipologiaObj && (tipologiaObj.richieste_tipologia_approvazione_automatica == 1 || tipologiaObj.richieste_tipologia_approvazione_automatica === "1");
        }

        /**
         * ! Create new richiesta
         * Validazione e stato sono basati sull'oggetto tipologia dall'API (nessun id hardcoded).
         */
        const sendingRequest = ref(false);
        function creaRichiesta() {
            //Formattazione per salvataggio dati
            const data_inizio_formatted = moment(richiesta.data_inizio).format("YYYY-MM-DD");
            const data_fine_formatted = richiesta.data_fine != "" ? moment(richiesta.data_fine).format("YYYY-MM-DD") : "";
            const ora_inizio_formatted = richiesta.ora_inizio != "" ? moment(richiesta.ora_inizio).format("HH:mm") : "";
            const ora_fine_formatted = richiesta.ora_fine != "" ? moment(richiesta.ora_fine).format("HH:mm") : "";

            if (!richiesta.tipologia) {
                openToast("La tipologia di richiesta è obbligatoria", "toast_danger");
                return;
            }

            const tipologiaObj = tipologie_richiesta.value.find(
                (t) => String(t.richieste_tipologia_id) === String(richiesta.tipologia)
            );
            if (!tipologiaObj) {
                openToast("Tipologia di richiesta non valida", "toast_danger");
                return;
            }

            const giornataIntera = isGiornataIntera(tipologiaObj);
            const startDate = moment(richiesta.data_inizio);
            const endDate = moment(richiesta.data_fine);
            const startTime = moment(richiesta.ora_inizio);
            const endTime = moment(richiesta.ora_fine);
            const todayDate = moment();
            const hasOrari = richiesta.ora_inizio != "" && richiesta.ora_inizio != null && richiesta.ora_fine != "" && richiesta.ora_fine != null;

            fieldFlag.value = false;

            // Permesso su più giorni (solo se impostazione HR attiva e tipologia id 1 per retrocompatibilità)
            if (richiesta.tipologia === "1" && showPermessoDateDiverse.value) {
                const isSameDay = startDate.format("YYYY-MM-DD") === endDate.format("YYYY-MM-DD");
                if (startDate.isBefore(todayDate, "day")) {
                    openToast("Non puoi inserire una richiesta per una data precedente ad oggi", "toast_danger");
                } else if (!isSameDay && !hasOrari) {
                    if (startDate.isAfter(endDate, "day")) {
                        openToast("La data di inizio non può essere successiva alla data di fine", "toast_danger");
                    } else {
                        fieldFlag.value = true;
                    }
                } else if (hasOrari) {
                    if (startTime.isAfter(endTime)) {
                        openToast("L'ora inizio non può essere maggiore dell'ora fine", "toast_danger");
                    } else if (startDate.isAfter(endDate, "day")) {
                        openToast("La data di inizio non può essere successiva alla data di fine", "toast_danger");
                    } else {
                        fieldFlag.value = true;
                    }
                } else {
                    fieldFlag.value = true;
                }
            } else if (giornataIntera) {
                // Qualsiasi tipologia a giornata intera (da API): solo date
                if (startDate.isBefore(todayDate, "day")) {
                    openToast("Non puoi inserire una richiesta per una data precedente ad oggi", "toast_danger");
                } else if (richiesta.data_fine && startDate.isAfter(endDate, "day")) {
                    openToast("La data di inizio non può essere successiva alla data di fine", "toast_danger");
                } else {
                    fieldFlag.value = true;
                }
            } else {
                // Tipologie con orari (o senza vincoli particolari)
                if (startDate.isBefore(todayDate, "day")) {
                    openToast("Non puoi inserire una richiesta per una data precedente ad oggi", "toast_danger");
                } else if (hasOrari && startTime.isAfter(endTime)) {
                    openToast("L'ora inizio non può essere maggiore dell'ora fine", "toast_danger");
                } else if (richiesta.data_fine && startDate.isAfter(endDate, "day")) {
                    openToast("La data di inizio non può essere successiva alla data di fine", "toast_danger");
                } else {
                    fieldFlag.value = true;
                }
            }

            if (fieldFlag.value) {
                sendingRequest.value = true;

                const data = new FormData();
                data.append("richieste_user_id", dipendenteID); //logged user
                data.append("richieste_dal", data_inizio_formatted);
                data.append("richieste_al", data_fine_formatted);
                data.append("richieste_ora_inizio", ora_inizio_formatted);
                data.append("richieste_ora_fine", ora_fine_formatted);
                if (richiesta.sottotipologia) {
                    data.append("richieste_sottotipologia", richiesta.sottotipologia);
                }
                data.append("richieste_tipologia", richiesta.tipologia);
                data.append("richieste_protocollo_inps", richiesta.protocollo_inps);
                if (richiesta.note) {
                    data.append("richieste_note", richiesta.note);
                }
                // Stato da proprietà tipologia (approvazione automatica)
                data.append("richieste_stato", isApprovazioneAutomatica(tipologiaObj) ? "2" : "1");
                //Utilizzo banca ore (1 o 0 in base alla selezione, vuoto se no impostao un valore ma poi cambiato tipo in melattia o legge104)
                data.append("richieste_utilizzo_banca_ore", richiesta.usa_banca_ore);

                if (richiesta.allegato) {
                    data.append("richieste_allegato", richiesta.allegato);
                }

                // Display the values
                /* for (const value of data.entries()) {
                    console.log(value[0] + ", " + value[1]);
                }
                return; */

                apiRichieste
                    .saveRichiesta(data)
                    .then((response) => {
                        if (response.data.status == 8) {
                            openToast(response.data.message, "toast_danger");
                        } else {
                            const res = response.data.data[0];
                            successResponse.value = true;
                            sendingRequest.value = false;
                            closeModalOnSubmit(successResponse, res);
                        }
                    })
                    .catch((error) => {
                        //console.error(error);
                        openToast("Errore durante la creazione della richiesta", "toast_danger");
                    })
                    .finally(() => {
                        sendingRequest.value = false;
                    });
            }
        }

        async function loadTipologieRichiesta() {
            try {
                const response = await apiRichieste.getTipologieRichiesta();
                if (response.status === 200 && response.data.status === 0) {
                    tipologie_richiesta.value = response.data.data;
                } else {
                    openToast("Errore durante la richiesta delle tipologie di richiesta effettuabili", "toast_danger");
                }
            } catch (error) {
                openToast("Si è verificato un errore durante la richiesta delle tipologie di richiesta effettuabili", "toast_danger");
            }
        }
        loadTipologieRichiesta();

        onMounted(() => {
            loadImpostazioniHr();
        });

        return {
            richiesta,
            creaRichiesta,
            closeModal,
            tipologie_richiesta,
            showOrario,
            showProtocolloInps,
            toggleField,
            arrowBackOutline,
            selectedTipologia,
            setUsaBancaOre,
            showBancaOre,
            showDataFine,
            //Sottotipologie
            sottotipologie,
            setSottotipologia,
            showSottocategorie,
            //Allegato
            currentFile,
            selezionaAllegato,
            removeAllegato,
            trash,
            // Banca ore
            showBancaOreSettings,
            attachOutline,
            sendingRequest
        };
    },
});
</script>

<style scoped>
ion-toolbar {
    --background: #086fa3;
    --color: #ffffff;
}

.page_content {
    width: 100%;
    position: relative;
    min-height: 100%;
    background: #f2f2f2;
    padding: 16px;
}

.fields {
    width: 100%;
    border-radius: 8px;
    /*padding: 10px;*/
    padding: 16px;
    /*box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);*/
    box-shadow: 0px 2px 5px 0px #00000040;
}

.field {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    margin-bottom: 8px;
}

.field_title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4px;
    color: #000000;
}

ion-item {
    --padding-start: 0;
    --padding-end: 0;
    --padding-left: 0;
    --padding-right: 0;
    --inner-padding-end: 0;
    --ripple-color: transparent;
    --background-activated: transparent;
    --background-activated-opacity: 0;
    margin-bottom: 4px;
}

ion-datetime,
ion-select {
    max-width: 100%;
    /*border: 1px solid #d1d5db;*/
    border: 1px solid #0000001a;
    border-radius: 6px;
    --padding-start: 12px;
    --padding-end: 12px;
    --padding-left: 12px;
    --padding-right: 12px;
    --placeholder-color: #00000080;
}

/* Set the icon color and opacity */
ion-select::part(icon) {
    /* display: flex;
    justify-content: center;
    align-items: center; */
    opacity: 1;
    color: #086fa3;
    /* background-color: #086fa3;
    border-radius: 50%; */
}

ion-input,
ion-textarea {
    --placeholder-color: #00000080;
    --padding-start: 12px !important;
    --padding-end: 12px !important;
    --padding-left: 12px !important;
    --padding-right: 12px !important;
    /*border: 1px solid #d1d5db;*/
    border: 1px solid #0000001a;
    border-radius: 6px;
    margin-top: 0;
}

.actions {
    margin-top: 16px;
    width: 100%;
    ;
}

.btn_richiesta {
    width: 100%;
    padding: 12px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
    text-align: center;
    background-color: #086fa3;
    color: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
}

.btn_richiesta:disabled {
    opacity: 0.5;
    pointer-events: none;
}

ion-button {
    --color: #ffffff;
}

/**
* Allegato richiesta
*/
.btn_select_allegato {
    display: inline-block;
    width: 100%;
    padding: 8px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 4px;
    text-align: center;
    color: #086fa3;
    background: #e36f3026;
    /*box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);*/
}

.btn_select_allegato ion-icon {
    font-size: 16px;
    color: #ffffff;
    background: #e36f30;
    border-radius: 50%;
    padding: 4px;
}

input[type="file"] {
    display: none;
}

.file_name {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
}

.file_name_title {
    font-size: 12px;
    font-weight: 500;
}

.btn_carica_allegato {
    margin-top: 24px;
    display: inline-block;
    width: 100%;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 20px;
    text-align: center;
    background-color: #086fa3;
    color: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
}

.icon_remove {
    /*color: rgb(239 68 68);*/
    background-color: #df000026;
    color: #c9372f;
    font-size: 12px;
    border-radius: 50%;
    padding: 4px;
}

.section_title {
    color: #1d1d1b;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
}

/** 28/03/2024 */
.required {
    color: #c70000;
}
</style>
